import { render } from "./meatandcheeseCTA.vue?vue&type=template&id=39e93878&scoped=true"
import script from "./meatandcheeseCTA.vue?vue&type=script&lang=js"
export * from "./meatandcheeseCTA.vue?vue&type=script&lang=js"

import "./meatandcheeseCTA.vue?vue&type=style&index=0&id=39e93878&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39e93878"]])

export default __exports__